import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnairePSA: QuestionnaireFlowType = {
    id: FindingAreasEnum.PayeSettlementAgreement,
    name: getFindingAreaDisplayText(FindingAreasEnum.PayeSettlementAgreement),
    questions: [
        {
            id: `${FindingAreasEnum.PayeSettlementAgreement}:Q1`,
            text: "Do you have a PSA in place?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.PayeSettlementAgreement}:Q2A`,
                no: `${FindingAreasEnum.PayeSettlementAgreement}:Q2B`,
            },
        },
        {
            id: `${FindingAreasEnum.PayeSettlementAgreement}:Q2A`,
            text: "Are your filings and payments up to date?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Amber,
            },
        },
        {
            id: `${FindingAreasEnum.PayeSettlementAgreement}:Q2B`,
            text: "Do you either not provide staff with perks/entertaining or report these to HMRC as a taxable benefit? For example this might be team drinks, staff lunches, staff gifts.",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.PayeSettlementAgreement}:Q3`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.PayeSettlementAgreement}:Q3`,
            text: "Do you assess the costs of staff entertaining/gifts from an employment tax perspective, considering the availablity of tax reliefs, such as the annual function exemption?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red,
            },
        }
    ],
};

export default questionnairePSA;